
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import epicService from '@/services/epic.service';

  @Component({
    computed: {
      ...mapGetters([
        'token'
      ])
    }
  })
  export default class EpicGamesUnlink extends Vue {
    created() {
      this.$store.watch(() => this.$store.getters.token, token => {
        epicService.unlinkEpicGames(this, token);
      })

      if (this.$store.getters.token != null) {
        epicService.unlinkEpicGames(this, this.$store.getters.token);
      }
    }
  }
